import { Center, Column, Spinner, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { EmptyScreen, SortingArrow, TSortValue } from '~/commonComponents';
import { CreatePostingButton } from '~/components/PermanentJobsV2/CreatePostingButton';
import { IJobPostEntity, JobPostingSortableField } from '~/domain/PermanentJobs';
import BriefcaseEmptyScreenIcon from '~/images/briefcase-empty-screen-icon.svg';
import { JobCard } from '../JobCard';
import { DefaultTableStyles } from './Constants';

interface IDefaultTableProps {
  data: IJobPostEntity[];
  formSorting: TSortValue;
  isLoading: boolean;
  onSortChanges(formSorting: TSortValue): void;
}

export const DefaultTable = ({
  data,
  formSorting,
  isLoading,
  onSortChanges,
}: IDefaultTableProps) => {
  const isEmptyData = data.length === 0;

  if (!isLoading && isEmptyData) {
    return (
      <EmptyScreen
        Icon={() => (
          <img
            alt="briefcase-empty-screen-icon"
            src={BriefcaseEmptyScreenIcon}
            height={170}
            width={170}
          />
        )}
        title="No jobs posted yet!"
        description={
          <Column align="center" gap={12}>
            <Typography as="span" color={colors.neutral[500]}>
              You haven’t posted any jobs yet. Post your first
              <br />
              job to start connecting with qualified dental
              <br />
              professionals in your area!
            </Typography>
            <CreatePostingButton />
          </Column>
        }
      />
    );
  }

  return (
    <>
      <table style={DefaultTableStyles.Table}>
        <thead>
          <tr>
            <th style={DefaultTableStyles.TableHeader.JobsCol}>
              <Typography as="span" bold color={colors.primary[500]} size="body_large">
                Jobs
              </Typography>
            </th>
            <th style={DefaultTableStyles.TableHeader.CandidatesCol}>
              <SortingArrow
                sorting={formSorting}
                name={JobPostingSortableField.CandidateCount}
                variant="primary"
                onChange={onSortChanges}
              >
                <Typography as="span" bold color={colors.primary[500]} size="body_large">
                  Candidates
                </Typography>
              </SortingArrow>
            </th>
            <th style={DefaultTableStyles.TableHeader.StatusCol}>
              <Typography as="span" bold color={colors.primary[500]} size="body_large">
                Status
              </Typography>
            </th>
          </tr>
        </thead>
        <tbody>
          {!isLoading &&
            data.map((it: IJobPostEntity) => (
              <tr key={it.id}>
                <td colSpan={3}>
                  <JobCard {...it} />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {isLoading && (
        <Center style={{ marginBlock: 32 }}>
          <Spinner centered variant="default" size="md" />
        </Center>
      )}
    </>
  );
};
